/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import PropTypes from "prop-types";
import { setChatWidgetParam } from "../../utilities/sierraChat";
import CardSection from "../CardSection/CardSection";
import ChatBotErrorMessage from "../ChatBotErrorMessage";
import styles from "./SierraChatButton.module.css";
import { withTranslation } from "@asosteam/asos-web-react-i18n";
import { trackClickByPlatform } from "src/utilities/isWebView";
import noticeError from "src/app/utilities/noticeError";

const SierraChatButton = ({
  sierraLoadError,
  isWebView,
  onStartChat,
  formatTranslation,
}) => {
  if (sierraLoadError) {
    return <ChatBotErrorMessage />;
  }

  const Component = isWebView ? "a" : "button";

  const handleClick = () => {
    setChatWidgetParam();
    onStartChat();
  };

  const handleWebViewClick = (e) => {
    const href = e.currentTarget.getAttribute("href");

    if (href) {
      trackClickByPlatform(href);
    }

    const noWebViewHref = isWebView && !href;

    if (noWebViewHref) {
      noticeError(new Error("sierra_missing_deeplink_href"));
    }
  };

  return (
    <CardSection title={formatTranslation("cchp_ai_chat_need_help")}>
      <Component
        className={styles.anchor}
        {...(isWebView && { href: "asos://chat", onClick: handleWebViewClick })}
        {...(!isWebView && { onClick: handleClick })}
      >
        {formatTranslation("cchp_ai_chat_start_chat_button")}
      </Component>
    </CardSection>
  );
};

SierraChatButton.propTypes = {
  isWebView: PropTypes.bool,
  sierraLoadError: PropTypes.bool,
  onStartChat: PropTypes.func.isRequired,
  formatTranslation: PropTypes.func.isRequired,
};

export default withTranslation(SierraChatButton);
